import './scss/app.scss'
import Home from './pages/Home'
import { Route, Routes } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'
import React from 'react'

const Cart = React.lazy(
  () => import(/*webpackChunkName: "Cart"*/ './pages/Cart'),
)
const FullPizza = React.lazy(
  () => import(/*webpackChunkName: "FullPizza"*/ './pages/FullPizza'),
)
const NotFound = React.lazy(
  () => import(/*webpackChunkName: "NotFound"*/ './pages/NotFound'),
)

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route path="" element={<Home />} />
        <Route
          path="cart"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <Cart />
            </React.Suspense>
          }
        />
        <Route
          path="pizza/:id"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <FullPizza />
            </React.Suspense>
          }
        />
        <Route
          path="*"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <NotFound />
            </React.Suspense>
          }
        />
      </Route>
    </Routes>
  )
}

export default App
